/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResourceFilter } from './ResourceFilter';
import {
    ResourceFilterFromJSON,
    ResourceFilterFromJSONTyped,
    ResourceFilterToJSON,
    ResourceFilterToJSONTyped,
} from './ResourceFilter';
import type { PermissionSearchSortingQuery } from './PermissionSearchSortingQuery';
import {
    PermissionSearchSortingQueryFromJSON,
    PermissionSearchSortingQueryFromJSONTyped,
    PermissionSearchSortingQueryToJSON,
    PermissionSearchSortingQueryToJSONTyped,
} from './PermissionSearchSortingQuery';
import type { RoleFilterRequest } from './RoleFilterRequest';
import {
    RoleFilterRequestFromJSON,
    RoleFilterRequestFromJSONTyped,
    RoleFilterRequestToJSON,
    RoleFilterRequestToJSONTyped,
} from './RoleFilterRequest';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { ApplicationFilterRequest } from './ApplicationFilterRequest';
import {
    ApplicationFilterRequestFromJSON,
    ApplicationFilterRequestFromJSONTyped,
    ApplicationFilterRequestToJSON,
    ApplicationFilterRequestToJSONTyped,
} from './ApplicationFilterRequest';
import type { PermissionSearchOrderByPaginationQuery } from './PermissionSearchOrderByPaginationQuery';
import {
    PermissionSearchOrderByPaginationQueryFromJSON,
    PermissionSearchOrderByPaginationQueryFromJSONTyped,
    PermissionSearchOrderByPaginationQueryToJSON,
    PermissionSearchOrderByPaginationQueryToJSONTyped,
} from './PermissionSearchOrderByPaginationQuery';

/**
 * 
 * @export
 * @interface PermissionSearchRequest
 */
export interface PermissionSearchRequest {
    /**
     * 
     * @type {ApplicationFilterRequest}
     * @memberof PermissionSearchRequest
     */
    applicationFilter?: ApplicationFilterRequest;
    /**
     * 
     * @type {PermissionSearchOrderByPaginationQuery}
     * @memberof PermissionSearchRequest
     */
    paginationQuery?: PermissionSearchOrderByPaginationQuery;
    /**
     * 
     * @type {Array<any>}
     * @memberof PermissionSearchRequest
     */
    permissionIds?: Array<any> | null;
    /**
     * 
     * @type {RoleFilterRequest}
     * @memberof PermissionSearchRequest
     */
    roleFilter?: RoleFilterRequest;
    /**
     * 
     * @type {PermissionSearchSortingQuery}
     * @memberof PermissionSearchRequest
     */
    sortingQuery?: PermissionSearchSortingQuery;
    /**
     * 
     * @type {string}
     * @memberof PermissionSearchRequest
     */
    textFilter?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof PermissionSearchRequest
     */
    userType?: UserType;
    /**
     * 
     * @type {ResourceFilter}
     * @memberof PermissionSearchRequest
     */
    resourceFilter?: ResourceFilter;
}



/**
 * Check if a given object implements the PermissionSearchRequest interface.
 */
export function instanceOfPermissionSearchRequest(value: object): value is PermissionSearchRequest {
    return true;
}

export function PermissionSearchRequestFromJSON(json: any): PermissionSearchRequest {
    return PermissionSearchRequestFromJSONTyped(json, false);
}

export function PermissionSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationFilter': json['applicationFilter'] == null ? undefined : ApplicationFilterRequestFromJSON(json['applicationFilter']),
        'paginationQuery': json['paginationQuery'] == null ? undefined : PermissionSearchOrderByPaginationQueryFromJSON(json['paginationQuery']),
        'permissionIds': json['permissionIds'] === undefined ? undefined : json['permissionIds'] === null ? null : json['permissionIds'],
        'roleFilter': json['roleFilter'] == null ? undefined : RoleFilterRequestFromJSON(json['roleFilter']),
        'sortingQuery': json['sortingQuery'] == null ? undefined : PermissionSearchSortingQueryFromJSON(json['sortingQuery']),
        'textFilter': json['textFilter'] === undefined ? undefined : json['textFilter'] === null ? null : json['textFilter'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'resourceFilter': json['resourceFilter'] == null ? undefined : ResourceFilterFromJSON(json['resourceFilter']),
    };
}

export function PermissionSearchRequestToJSON(json: any): PermissionSearchRequest {
    return PermissionSearchRequestToJSONTyped(json, false);
}

export function PermissionSearchRequestToJSONTyped(value?: PermissionSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationFilter': ApplicationFilterRequestToJSON(value['applicationFilter']),
        'paginationQuery': PermissionSearchOrderByPaginationQueryToJSON(value['paginationQuery']),
        'permissionIds': value['permissionIds'],
        'roleFilter': RoleFilterRequestToJSON(value['roleFilter']),
        'sortingQuery': PermissionSearchSortingQueryToJSON(value['sortingQuery']),
        'textFilter': value['textFilter'],
        'userType': UserTypeToJSON(value['userType']),
        'resourceFilter': ResourceFilterToJSON(value['resourceFilter']),
    };
}

